/**
 * Helper functions for language-specific content selection
 */

/**
 * Get the localized field value based on language
 * @param obj Object containing localized fields
 * @param fieldBase Base field name (e.g., 'name', 'label', 'faculty')
 * @param language Current language ('zh' or 'en')
 * @param fallback Fallback field name if localized field is not available
 * @returns Localized value or fallback
 */
export function getLocalizedField<T extends Record<string, any>>(
  obj: T,
  fieldBase: string,
  language: string,
  fallback?: string
): string {
  if (language === 'zh') {
    const tchField = `${fieldBase}_tch`;
    const zhField = `${fieldBase}_zh`;
    return obj[tchField] || obj[zhField] || obj[fallback || fieldBase] || '';
  } else {
    const engField = `${fieldBase}_eng`;
    const enField = `${fieldBase}_en`;
    return obj[engField] || obj[enField] || obj[fallback || fieldBase] || '';
  }
}

/**
 * Get programme name in current language
 */
export function getProgrammeName(programmeDetails: any, language: string): string {
  return getLocalizedField(programmeDetails, 'name', language);
}

/**
 * Get faculty name in current language
 */
export function getFacultyName(programmeDetails: any, language: string): string {
  return getLocalizedField(programmeDetails, 'faculty', language);
}

/**
 * Get label from an object with label_tch/label_eng fields
 */
export function getLabel(item: { label_tch?: string; label_eng?: string; label?: string }, language: string): string {
  return getLocalizedField(item, 'label', language);
}
